import { Disclosure } from '@headlessui/react';
import { mergeTwClasses } from '@utils/merge-tw-classes/merge-tw-classes';

import { AccordionProps } from './accordion.type';

export const Accordion = ({ defaultOpen = false, children, className, ...props }: AccordionProps) => (
  <Disclosure
    as='div'
    defaultOpen={defaultOpen}
    className={mergeTwClasses(
      'overflow-hidden rounded-lg border bg-neutral-0 border-neutral-8 dark:bg-neutral-70 dark:border-neutral-50',
      className
    )}
    {...props}>
    {children}
  </Disclosure>
);
